export default '/Users/yawjosephetse/Developer/github/repetere/modelx/node_modules/csvtojson/libs/core'